module.exports = __webpack_public_path__ + "logo-orkla-tagline-fi-828d98fcdd059e5df4088239159dc8f5.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/logo-orkla-tagline-fi.svg
// module id = 67
// module chunks = 0